export const generateUrl = (inputDataString: string): string => {
    const blob = new Blob([inputDataString], { type: "text/vtt" });
    return URL.createObjectURL(blob);
};

const saveVttToPc = (inputDataString: string, filename: string): void => {
    const url = generateUrl(inputDataString);
    const link = document.createElement("a");
    link.download = filename;
    link.href = url;
    link.click();
    URL.revokeObjectURL(url);
};

export default saveVttToPc;
